export default __webpack_public_path__ + "static/media/theMart_logo_new.46af3d4c.png";